import { FormControl, FormHelperText, FormLabel, Input} from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateQuestionSetting } from "../../actions";
function NameFunction() {
  const [error, setError] = React.useState(false);
  const { question, questionId, questionsList } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
    questionsList: state.questionsList,
  }));
  const dispatch = useDispatch();
  const handleCheckDisable = () => {
    let listNameCheck = Object.values(questionsList)?.map(
      (question) => question.name
    );
    listNameCheck.splice(listNameCheck.indexOf(question.name), 1);
    setError(listNameCheck.indexOf(question.name) > -1);
  };
  useEffect(() => {
    handleCheckDisable();
  }, [questionId]);
  return (
      <>
        <FormLabel component="legend" style={{color:"#000", fontWeight:"bold", fontSize:"1.2rem"}}>Question Name</FormLabel>
        <FormControl fullWidth style={{padding:"15px"}}>
          {/* <InputLabel htmlFor={`${questionId}_name`}  shrink style={{fontSize:'20px',color:"#000"}}>Name:<span style={{ color: 'red' }}> * </span></InputLabel> */}
          <FormLabel style={{color:"#000", fontWeight: "bold"}}>
              Name:<span style={{ color: 'red' }}> * </span>
          </FormLabel>
          <Input 
            style={{marginTop:'0'}}
            id={`${questionId}_name`} 
            error={error || !question.name || (question.name && !question.name?.match(/^[a-zA-Z0-9_-]+$/))}
            disabled={
            window.DisableQuestion?.edit_name?.indexOf(questionId) >
                -1 && !error
            } 
            onChange={(e) => {
            dispatch(
                updateQuestionSetting(questionId, "name", e.target.value)
            );
            }}
            onBlur={handleCheckDisable}
            value={question.name|| ''}  
          />
          
          <FormHelperText error id={`${questionId}_name_helper_text`} >{!question.name?.match(/^[a-zA-Z0-9_-]+$/) ? "Question name empty or contain spaces, special character" : error ? "Duplicate question name" : ""}</FormHelperText>
        </FormControl>
      </>
  )
}

export default NameFunction;
